import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { IsoTimestamp } from '@modernloop/shared/datetime';
import { Stack, Typography } from '@mui/material';

import { useDurationLabel } from 'src/components/DurationLabel';

type Props = {
  actionsJSX: JSX.Element | null;
  heading: string;
  selfScheduleOptions?: {
    createdAt: IsoTimestamp | undefined;
    selfScheduleEmailSentAt?: IsoTimestamp | undefined;
    creatorName: string;
  };
};

const RejectedScheduleAlert: FC<Props> = ({ actionsJSX, heading, selfScheduleOptions }) => {
  const { t } = useTranslation();
  const emailSentAtDurationLabel = useDurationLabel(selfScheduleOptions?.selfScheduleEmailSentAt);
  const durationLabel = useDurationLabel(selfScheduleOptions?.createdAt);

  return (
    <Stack>
      <Typography color="error" variant="subtitle1">
        {heading}
      </Typography>

      {selfScheduleOptions?.selfScheduleEmailSentAt && (
        <Typography color="error" variant="caption">
          {t('hiring-dashboard-tasks:tasks.rejectedSchedule.linkSentToCandidate', {
            creatorName: selfScheduleOptions.creatorName,
            durationLabel: emailSentAtDurationLabel,
          })}
        </Typography>
      )}
      {!selfScheduleOptions?.selfScheduleEmailSentAt && (
        <Typography color="error" variant="caption">
          {t('hiring-dashboard-tasks:tasks.rejectedSchedule.requestCreated', {
            durationLabel,
            creatorName: selfScheduleOptions?.creatorName,
          })}
        </Typography>
      )}
      {actionsJSX}
    </Stack>
  );
};

export default RejectedScheduleAlert;
